(() => {
  const banner = document.querySelector('[data-ic-consent]');
  if (!banner || !window.Shopify?.loadFeatures) return;

  const preferences = banner.querySelector('[data-ic-consent-preferences]');
  const summary = banner.querySelector('[data-ic-consent-summary]');
  const manageButton = banner.querySelector('[data-ic-consent-manage]');
  const closeButton = banner.querySelector('[data-ic-consent-close]');
  const status = banner.querySelector('[data-ic-consent-status]');
  const fields = Object.fromEntries(
    [...banner.querySelectorAll('[data-ic-consent-field]')].map(input => [input.dataset.icConsentField, input])
  );
  let privacyApi;
  let returnFocus;
  const showEverywhere = banner.dataset.showEverywhere === 'true';

  const googleConsent = choices => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      analytics_storage: choices.analytics ? 'granted' : 'denied',
      ad_storage: choices.marketing ? 'granted' : 'denied',
      ad_user_data: choices.marketing ? 'granted' : 'denied',
      ad_personalization: choices.marketing ? 'granted' : 'denied',
      functionality_storage: choices.preferences ? 'granted' : 'denied',
      personalization_storage: choices.preferences ? 'granted' : 'denied',
      security_storage: 'granted'
    });
  };

  const currentChoices = () => {
    const current = privacyApi.currentVisitorConsent();
    return {
      preferences: current.preferences === 'yes',
      analytics: current.analytics === 'yes',
      marketing: current.marketing === 'yes'
    };
  };

  const fillChoices = choices => Object.entries(fields).forEach(([name, input]) => {
    input.checked = Boolean(choices[name]);
  });

  const hideBanner = () => {
    banner.hidden = true;
    document.documentElement.classList.remove('ic-consent-is-open');
  };

  const showBanner = () => {
    banner.hidden = false;
    document.documentElement.classList.add('ic-consent-is-open');
  };

  const openPreferences = trigger => {
    returnFocus = trigger || document.activeElement;
    fillChoices(currentChoices());
    summary.hidden = true;
    preferences.hidden = false;
    manageButton?.setAttribute('aria-expanded', 'true');
    showBanner();
    closeButton?.focus();
  };

  const closePreferences = () => {
    preferences.hidden = true;
    summary.hidden = false;
    manageButton?.setAttribute('aria-expanded', 'false');
    const current = privacyApi.currentVisitorConsent();
    const hasUnansweredChoice = ['preferences', 'analytics', 'marketing'].some(name => current[name] === '');
    if (!hasUnansweredChoice || (!showEverywhere && !privacyApi.shouldShowBanner())) hideBanner();
    returnFocus?.focus?.();
  };

  const save = choices => {
    status.textContent = 'Saving your choices…';
    privacyApi.setTrackingConsent(choices, () => {
      googleConsent(choices);
      status.textContent = 'Your cookie choices have been saved.';
      document.dispatchEvent(new CustomEvent('industracare:consent-updated', { detail: choices }));
      window.setTimeout(() => {
        hideBanner();
        preferences.hidden = true;
        summary.hidden = false;
        manageButton?.setAttribute('aria-expanded', 'false');
        status.textContent = '';
      }, 450);
    });
  };

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (error || !window.Shopify.customerPrivacy) return;
    privacyApi = window.Shopify.customerPrivacy;

    const rawConsent = privacyApi.currentVisitorConsent();
    const existing = currentChoices();
    googleConsent({
      preferences: privacyApi.preferencesProcessingAllowed(),
      analytics: privacyApi.analyticsProcessingAllowed(),
      marketing: privacyApi.marketingAllowed()
    });
    fillChoices(existing);
    const hasUnansweredChoice = ['preferences', 'analytics', 'marketing'].some(name => rawConsent[name] === '');
    if ((showEverywhere && hasUnansweredChoice) || (!showEverywhere && privacyApi.shouldShowBanner())) showBanner();

    banner.querySelectorAll('[data-ic-consent-accept]').forEach(button => {
      button.addEventListener('click', () => save({ preferences: true, analytics: true, marketing: true }));
    });
    banner.querySelector('[data-ic-consent-reject]')?.addEventListener('click', () => {
      save({ preferences: false, analytics: false, marketing: false });
    });
    banner.querySelector('[data-ic-consent-save]')?.addEventListener('click', () => save({
      preferences: fields.preferences.checked,
      analytics: fields.analytics.checked,
      marketing: fields.marketing.checked
    }));
    manageButton?.addEventListener('click', event => openPreferences(event.currentTarget));
    closeButton?.addEventListener('click', closePreferences);
    document.querySelectorAll('[data-ic-open-consent]').forEach(button => {
      button.addEventListener('click', event => openPreferences(event.currentTarget));
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !banner.hidden && !preferences.hidden) closePreferences();
    });
  });
})();
